<template>
    <div :class="{'notification-container': true, 'notification-container-empty' : items.length===0}">
        <transition-group name="ntf" tag="div" mode="out">
            <div v-for="item in items" :key="item.id" :class="'notification notification-'+item.options.type" @click="removeItem(item.id)">
                <div class="notification-message">
                    <h4 class="title" v-if="item.title">{{ item.title }}</h4>
                    <div class="message" v-if="item.message" v-html="item.message"/>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                message: null,
                title: null,
                options: {
                    type: 'success',
                    duration: 2000,
                    permanent: false
                },
                items: [],
                idx: 0
            }
        },
        methods: {
            createUUID() {
                const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
                return pattern.replace(/[xy]/g, c => {
                    const r = (Math.random() * 16) | 0
                    const v = c === 'x' ? r : (r & 0x3) | 0x8
                    return v.toString(16)
                })
            },
            addItem(type, title, message, options) {
                let defaultOptions = {
                    type: type,
                    duration: this.options.duration,
                    permanent: this.options.permanent
                }
                let itemOptions = Object.assign({}, defaultOptions, options)

                let idx = this.createUUID()
                var newItem = {
                    id: idx,
                    message: message,
                    title: title,
                    options: itemOptions
                }

                this.items.push(newItem)

                if (itemOptions.permanent === false) {
                    setTimeout(() => {
                        this.removeItem(idx)
                    }, itemOptions.duration)
                }
            },
            removeItem(uid) {
                this.items = Object.assign([], this.items.filter(x => x.id !== uid))
            },
            removeAll() {
                this.items = []
            }
        }
    }
</script>
<style lang="scss">
    @import '~@/assets/variables.scss';

    $border-radius: 0.3rem;

    .notification-container {
        box-sizing: border-box;
        position: fixed;
        top: 0;
        right: 0;
        z-index: 999999;
        width: 320px;
        padding: 0px 15px;
        max-height: calc(100% - 30px);
        overflow-x: hidden;
        overflow-y: auto;
    }

    .notification {
        box-sizing: border-box;
        padding: 15px 15px 15px 58px;
        border-radius: 2px;
        cursor: pointer;
        font-size: 1em;
        line-height: 1.2em;
        position: relative;
        opacity: 0.9;
        margin-top: 15px;
    }

    .notification .title {
        font-size: 1em;
        line-height: 1.2em;
        font-weight: bold;
        margin: 0 0 5px 0;
    }

    .notification:hover,
    .notification:focus {
        opacity: 1;
    }

    .notification-enter {
        visibility: hidden;
        transform: translate3d(100%, 0, 0);
    }

    .notification-enter.notification-enter-active {
        visibility: visible;
        transform: translate3d(0, 0, 0);
        transition: all 0.4s;
    }

    .notification-leave {
        visibility: visible;
        transform: translate3d(0, 0, 0);
    }

    .notification-leave.notification-leave-active {
        visibility: hidden;
        transform: translate3d(100%, 0, 0);
        transition: all 0.4s;
    }

    .notification {
        border-radius: $border-radius;
        padding: 20px;
        font-size: 1rem;
    }

    .notification:before {
        content: "";
        display: none;
    }

    .notification-primary {
        color: $primary;
        background-color: white;
        border: 1px solid $primary;
        opacity: 1;

        .notification-message {
            .title {
                color: white;
            }

            .message {
                color: $primary;
            }
        }

        &.filled {
            color: black;
            background-color: white;

            .notification-message {
                .title {
                    color: black;
                }

                .message {
                    color: black;
                }
            }
        }
    }

    .notification-secondary {
        color: $secondary;
        background-color: white;
        border: 1px solid $secondary;
        opacity: 1;

        .notification-message {
            .title {
                color: $secondary;
            }

            .message {
                color: black;
            }
        }

        &.filled {
            color: black;
            background-color: $secondary;

            .notification-message {
                .title {
                    color: black;
                }

                .message {
                    color: black;
                }
            }
        }
    }

    .notification-info {
        color: $info;
        background-color: white;
        border: 1px solid $info;
        opacity: 1;

        .notification-message {
            .title {
                color: $info;
            }

            .message {
                color: black;
            }
        }

        &.filled {
            color: black;
            background-color: $info;

            .notification-message {
                .title {
                    color: black;
                }

                .message {
                    color: black;
                }
            }
        }
    }

    .notification-success {
        color: $success;
        background-color: white;
        border: 1px solid $success;
        opacity: 1;

        .notification-message {
            .title {
                color: $success;
            }

            .message {
                color: black;
            }
        }

        &.filled {
            color: black;
            background-color: $success;

            .notification-message {
                .title {
                    color: black;
                }

                .message {
                    color: black;
                }
            }
        }
    }

    .notification-warning {
        color: $warning;
        background-color: white;
        border: 1px solid $warning;
        opacity: 1;

        .notification-message {
            .title {
                color: $warning;
            }

            .message {
                color: black;
            }
        }

        &.filled {
            color: black;
            background-color: $warning;

            .notification-message {
                .title {
                    color: black;
                }

                .message {
                    color: black;
                }
            }
        }
    }

    .notification-error {
        color: $danger;
        background-color: white;
        border: 1px solid $danger;
        opacity: 1;

        .notification-message {
            .title {
                color: $danger;
            }

            .message {
                color: black;
            }
        }

        &.filled {
            color: black;
            background-color: $danger;

            .notification-message {
                .title {
                    color: black;
                }

                .message {
                    color: black;
                }
            }
        }
    }

    .ntf-enter {
        opacity: 0;
    }

    .ntf-leave {
        opacity: 1;
    }

    .ntf-enter-active {
        animation: slideInRight 0.4s;
    }

    .ntf-leave-active {
        animation: slideOutRight 0.4s;
    }

    @-webkit-keyframes slideInRight {
        from {
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
            visibility: visible;
        }

        to {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    @keyframes slideInRight {
        from {
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
            visibility: visible;
        }

        to {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }
    }

    .slideInRight {
        -webkit-animation-name: slideInRight;
        animation-name: slideInRight;
    }

    @-webkit-keyframes slideOutRight {
        from {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }

        to {
            visibility: hidden;
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }
    }

    @keyframes slideOutRight {
        from {
            -webkit-transform: translate3d(0, 0, 0);
            transform: translate3d(0, 0, 0);
        }

        to {
            visibility: hidden;
            -webkit-transform: translate3d(100%, 0, 0);
            transform: translate3d(100%, 0, 0);
        }
    }

    .slideOutRight {
        -webkit-animation-name: slideOutRight;
        animation-name: slideOutRight;
    }
</style>
